export default {
  title: 'Nieuw menu',
  headers: {
    edit_time: 'Tijd bewerken',
  },
  labels: {
    select_all: 'Alles selecteren',
  },
  fields: {
    name: {
      label: 'Naam',
      placeholder: 'Voer menunaam in',
    },
    sorting_order: {
      label: 'Weergavevolgorde menu',
      placeholder: 'Voer weergavevolgorde menu in',
    },
    has_separate_schedule: {
      label: 'Wijkt af van reguliere openingstijden',
    },
    selected_days: {
      label: 'Geselecteerde dagen',
    },
    opening_time: {
      label: 'Openingstijd',
    },
    closing_time: {
      label: 'Sluitingstijd',
    },
  },
  buttons: {
    add_opening_time: 'Openingstijd toevoegen',
    add: 'Toevoegen',
    cancel: 'Annuleren',
    save: 'Opslaan',
    close: 'Sluiten',
  },
  feedback: {
    missing_info: 'Ontbrekende informatie',
  },
  toasts: {
    menu_got_created: 'Menu aangemaakt',
    menu_got_updated: 'Menu is bijgewerkt',
  },
};
